import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  fr: {
    msg_obligatoire: 'Ce champ est obligatoire',
    msg_lg_mini: 'La longueur minimum est de {nb} caractères',
    msg_lg_maxi: 'La longueur maximum est de {nb} caractères',
    msg_champ_courriel: 'Ce champ doit contenir une adresse courriel',
    msg_champ_numeric: 'Ce champ doit contenir une valeur numérique',
    msg_mdp_identique: 'Les mots de passe doivent être identiques',
    msg_mdp_regles:
      'Le mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule et un chiffre.',
    login_ouvrir: 'Ouverture de session',
    login_codeUsager: 'Code usager',
    login_pwd: 'Mot de passe',
    login_connecter: 'Ouverture de session',
    login_connecter_bouton: 'Se connecter',
    no_client_saq: 'Numéro de client SAQ',
    mdp_oublie_lien: 'Mot de passe oublié?',
    mdp_oublie_titre: 'Mot de passe oublié',
    mdp_oublie_into:
      'Veuillez inscrire votre adresse courriel ainsi que votre numéro de client SAQ',
    mdp_oublie_courriel: 'Courriel',
    mdp_oublie_noclient: 'Numéro de client SAQ',
    mdp_oublie_submit_btn: 'Réinitialiser mon mot de passe',
    mdp_oublie_confirmation_envoi_token:
      "Si les informations fournis correspondent, un courriel sera envoyé à l'adresse fournie avec les instructions suivantes pour réinitialiser votre mot de passe. Si vous ne recevez aucun courriel et que vous pensez que les informations sont exactes, veuillez nous contacter.",
    mdp_oublie_reinitialiser_titre: 'Réinitialisation de votre mot de passe',
    mdp_oublie_reinitialiser_token_not_found:
      "Le jeton utilisé est expiré ou n'a pas été trouvé. Utilisez le lien ci-bas pour en obtenir un nouveau.",
    mdp_oublie_reinitialiser_mot_de_passe: 'Nouveau mot de passe',
    mdp_oublie_reinitialiser_mot_de_passe2: 'Confirmation du mot de passe',
    mdp_oublie_btn_sauvegarder: 'Sauvegarder',
    mdp_oublie_reinitialiser_succes:
      'Votre mot de passe a été réinitialisé avec succès!',
    mdp_oublie_reinitialiser_erreur_invalid_token:
      'Le jeton de réinitialisation utilisé semble être expiré ou non existant. Vous pouvez en obtenir un nouveau sur la page de mot de passe oublié.',
    mdp_oublie_reinitialiser_succes_instructions:
      "Vous pouvez maintenant vous connecter à partir de la page d'authentification.",
    mdp_oublie_reinitialiser_erreur_compte_verouille:
      'Votre compte a été vérouillé par un administrateur. Veuillez nous contacter pour remédier à la situation.',
    profil_modifier_mdp_lien: 'Modifier',
    profil_modifier_mdp_popup_titre: 'Modification du mot de passe',
    profil_modifier_mdp_popup_ancien_mdp: 'Ancien mot de passe*',
    profil_modifier_mdp_popup_nouveau_mdp: 'Nouveau mot de passe*',
    profil_modifier_mdp_popup_confirmation_mdp: 'Confirmation du mot de passe*',
    profil_modifier_mdp_popup_sauvegarder: 'Sauvegarder',
    profil_modifier_mdp_popup_annuler: 'Annuler',
    profil_modifier_mdp_popup_champs_requis: 'indique un champs requis',
    profil_modifier_mdp_popup_ancienMdp_invalide: 'Votre ancien mot de passe ne correspond pas, veuillez réassayer à nouveau.',
    profil_modifier_mdp_popup_statut_invalide: 'Votre compte est vérouillé, veuillez nous contacter pour remédier à la situation',
    profil_modifier_mdp_popup_succes: 'Votre mot de passe a été modifié avec succès!',
    profil_utilisateur_obligatoire: "Le nom d'utilisateur est obligatoire",
    profil_nom_contact_obligatoire: "Le nom du responsable est obligatoire",
    profil_courriel_contact_obligatoire: "L'adresse courriel est obligatoire",
    xls: {
      noOWAgent_inconnu: "Le numéro client de l'agent {p} est inconnu",
      noOWClient_inconnu: 'Le numéro client {p} est inconnu',
      noOWAgent_pas_autorise: "Le numéro d'agence dans le fichier ne correspond pas à votre numéro de client",
      noProduit_invalide: 'No de produit invalide: {p}',
      produit_inconnu: "Aucun produit n'existe avec  le code {p}",
      agentAutorisePourClient: "Vous n'avez pas l'autorisation d'effectuer une commande pour le compte de ce client. Veuillez communiquer avec ce dernier pour obtenir l'autorisation.",
      typeClient_incompatible_typeLivraison: "Le type d'instruction de livraison ne correspond pas à celle du client",
      succursale_invalide: "La succursale {p} dans le fichier n'est pas une succursale autorisée",
      date_invalide: "La date dans le fichier est invalide",
      typeClient_ans_instruction_demande_etablissement: "Le type de livraison demandée est à l'établissement mais le client n'a pas ce type d'instruction de livraison",
      produit_pas_inventaire: "Un des produits dans le fichier n'a pas suffisament d'inventaire",
      doit_avoir_noclient: "Pour ce type de client, un numéro de client est obligatoire",
      client_code_blocage: "Ce client ne peut recevoir de commandes présentement. Pour plus de détails, celui-ci doit communiquer avec notre Service de la comptabilité au 514 254-8686, option 2.",
      noSuccursale_invalide: "Il doit y avoir un numéro de succursale",
      typeLivraison_invalide: "Le fichier doit contenir un type de livraison"
    }
  },
  en: {
    msg_obligatoire: 'This field is required',
    msg_lg_mini: 'The minmum length is {nb} caracters',
    msg_lg_maxi: 'The maximum length is {nb} caracters',
    login_ouvrir: 'Open session',
    login_codeUsager: 'User ID',
    login_pwd: 'Password',
    login_connecter: 'Connect'
  }
}

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'en',
  messages
})

export default i18n
